<h1
  class="h3"
  data-test="search-title"
  [hidden]="!searchName"
>{{ searchName }}</h1>
<flo-search-input
  [formControl]="searchControl"
  class="vertical-search__search-input"
  data-test="search-container"
></flo-search-input>
<ng-content></ng-content>
<button
  name="Filters"
  class="facets-list__expand-toggle btn btn-secondary"
  [hidden]="!currentFacets || !currentFacets.length"
  (click)="onExpandFacets.next(true)"
  floAnalytics
  [analyticsProperties]="getFiltersAnalyticsProperties()"
  tagName="Link"
  >Filters</button
>

<ul
  class="facets-list"
  *ngIf="selectedFacets$ | async as selectedFacets"
  [class.facets-list--expanded]="onExpandFacets | async"
>
  <h3 class="facets-list__heading">Filter Videos</h3>
  <span
    class="facets-list__results-count"
    data-test="search-count"
  >{{ searchResultsCountString }}</span>
  <button
    class="facets-list__clear-selection-button primary-color-text"
    (click)="onClearFilters.next(selectedFacets)"
    [hidden]="!selectedFacets.length"
  >Clear Filters <span class="svg-vertical-align-middle" data-test="clear-facets"><flo-svg-icon icon="icon-times"></flo-svg-icon></span
  ></button>

  <li *ngFor="let facet of currentFacets; trackBy: trackByFacet" class="facet">
    <h4
      class="facet__title"
      data-test="facet-title"
    >{{ facet.displayName }}</h4>
    <ul
      class="subfacets-list"
      [class.subfacets-list--expanded]="facet.isExpanded"
    >
      <li
        *ngFor="let subfacet of facet.subfacets; trackBy: trackByFacet"
        class="subfacet"
        data-test="subfacet-list"
        (click)="onSelectFacet.next({ facet: facet, subfacet: subfacet })"
        [class.subfacet--disabled]="subfacet.count < 1"
        [class.subfacet--selected]="isFacetSelected(selectedFacets, subfacet)"
        [class.primary-color-text]="isFacetSelected(selectedFacets, subfacet)"
        floAnalytics
        tagName="Filter"
        [analyticsProperties]="getFacetAnalyticsProperties(facet, subfacet)"
      >
        <h5
          class="subfacet__title"
          data-test="subfacet-title"
          [class.primary-color-text]="isFacetSelected(selectedFacets, subfacet)"
        >{{ subfacet.value }}</h5>
        <span class="subfacet__deselect-icon svg-vertical-align-middle">
          <flo-svg-icon icon="icon-times" width="13px"></flo-svg-icon>
        </span>
        <span
          class="subfacet__result-count"
          [class.primary-color-text]="isFacetSelected(selectedFacets, subfacet)"
        >{{ subfacet.count }}</span>
      </li>
    </ul>
    <button
      name="More"
      class="subfacets-list__expand-toggle primary-color-text"
      data-test="more"
      [hidden]="facet.subfacets?.length <= 5"
      (click)="facet.isExpanded = !facet.isExpanded"
      floAnalytics
      [analyticsProperties]="getMoreAnalyticsProperties(facet)"
      tagName="Link"
    >{{ facet.isExpanded
      ? 'Less'
      : 'More (+' + (facet.subfacets?.length - 5) + ')'
    }}</button>
  </li>

  <div class="facets-list__button-group">
    <button
      class="facets-list__button facets-list__button--apply-selection btn btn-primary"
      (click)="onApplyFilters.next(selectedFacets)"
      floAnalytics
      [analyticsProperties]="getApplyAnalyticsProperties(selectedFacets)"
      eventName="Filter Applied"
      >Apply</button
    >
    <button
      class="facets-list__button facets-list__button--cancel-selection btn btn-secondary"
      (click)="onCancelFilters.next(selectedFacets)"
      floAnalytics
      [analyticsProperties]="getApplyAnalyticsProperties(selectedFacets)"
      eventName="Filter Canceled"
      >Cancel</button
    >
  </div>
</ul>
